<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-tabs v-model="indiceAba" class="mb-2" @change="onAbaChange">
            <v-tab v-for="a in abas" :key="a.tipo">{{ a.label }}</v-tab>
        </v-tabs>
        <v-progress-linear v-if="!configCarregada" indeterminate />
        <HistoricoAlteracoesRotasPainel v-else-if="abaAtual === TIPO_ALTERACOES" />
        <HistoricoRotasOtimizadasPainel
            v-else-if="abaAtual"
            :key="abaAtual"
            :por-unidade="abaAtual === TIPO_UNIDADE"
        />
    </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import { podeVerHistoricoRotasOtimizadas } from '@/utils/historicoRotasOtimizadas';
import HistoricoRotasOtimizadasPainel from './HistoricoRotas/HistoricoRotasOtimizadasPainel.vue';
import HistoricoAlteracoesRotasPainel from './HistoricoRotas/HistoricoAlteracoesRotasPainel.vue';

/** Valores de ?tipo: os mesmos que o botão "Histórico" das abas Comparação já manda (linha/unidade). */
const TIPO_LINHA = 'linha';
const TIPO_UNIDADE = 'unidade';
const TIPO_ALTERACOES = 'alteracoes';

export default {
    name: 'RELHistoricoRotas',
    components: { HistoricoRotasOtimizadasPainel, HistoricoAlteracoesRotasPainel },
    data: () => ({
        TIPO_UNIDADE,
        TIPO_ALTERACOES,
        indiceAba: 0,
        /** Quem só tem a tela legada RELHistoricoAlteracoesRotas vê apenas a aba Alterações. */
        veOtimizadas: false,
        /** Os painéis montam o período padrão pelo dia operacional das Configurações. */
        configCarregada: false,
    }),
    computed: {
        abas() {
            const abas = [];
            if (this.veOtimizadas) {
                abas.push(
                    { tipo: TIPO_LINHA, label: this.$t('routesHistory.tabs.lines') },
                    { tipo: TIPO_UNIDADE, label: this.$t('routesHistory.tabs.units') },
                );
            }
            abas.push({ tipo: TIPO_ALTERACOES, label: this.$t('routesHistory.tabs.changes') });
            return abas;
        },
        abaAtual() {
            const aba = this.abas[this.indiceAba];
            return aba ? aba.tipo : null;
        },
    },
    created() {
        this.veOtimizadas = podeVerHistoricoRotasOtimizadas();
        // Antes da renderização: a aba vinda da query não dispara o @change do v-tabs
        const tipo = this.$route ? this.$route.query.tipo : null;
        const idx = this.abas.findIndex((a) => a.tipo === tipo);
        this.indiceAba = idx >= 0 ? idx : 0;
        this.carregaConfig();
    },
    methods: {
        /** O store só recebe as Configurações no login: depois de recarregar a página, busca de novo. */
        async carregaConfig() {
            if (this.$store.getters['config/horaInicialDiaOperacao'] == null) {
                try {
                    const res = await apiController.request(apiController.endpoints.getallConfig, { silent: true });
                    if (res.data && res.data[0]) this.$store.commit('config/setConfig', res.data[0]);
                } catch (e) {
                    // sem Configurações o período padrão começa à meia-noite
                }
            }
            this.configCarregada = true;
        },
        onAbaChange() {
            // Troca de aba descarta o filtro de linha/unidade vindo da Comparação
            const tipo = this.abaAtual;
            if (tipo && this.$route.query.tipo !== tipo) {
                this.$router.replace({ query: { tipo } }).catch(() => {});
            }
        },
    },
};
</script>
